import { render, staticRenderFns } from "./pane-employees.vue?vue&type=template&id=52482304&scoped=true"
import script from "./pane-employees.vue?vue&type=script&lang=js"
export * from "./pane-employees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52482304",
  null
  
)

export default component.exports